export const GenericImage = require('./generic-image.webp');
